/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagenotcheckedin4Inputs */

const en_ticketpagenotcheckedin4 = /** @type {(inputs: Ticketpagenotcheckedin4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not checked in yet`)
};

const de_ticketpagenotcheckedin4 = /** @type {(inputs: Ticketpagenotcheckedin4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch nicht eingecheckt`)
};

/**
* | output |
* | --- |
* | "Not checked in yet" |
*
* @param {Ticketpagenotcheckedin4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagenotcheckedin4 = /** @type {((inputs?: Ticketpagenotcheckedin4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagenotcheckedin4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagenotcheckedin4(inputs)
	return de_ticketpagenotcheckedin4(inputs)
});
export { ticketpagenotcheckedin4 as "ticketPageNotCheckedIn" }